theme.ProductPage =  function(){
   $('.product-modal').fancybox({type: 'ajax',openMethod: 'superscaleIn',openEffect: 'none',closeEffect: 'none',helpers: {overlay: {locked: false} },afterLoad: function() {
    var sections = new theme.Sections();sections.register('product', theme.Product);
    if($('.product-single__photos').find('.video_content').length  >0 && typeof YT == 'undefined'){
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }        }); 
  
   $('.alternate_products').click(function(){
      $.fancybox.open( $('#related-item-popup'), {
        touch: false,
        infobar: false
      });
        });
  
    $("modal-opener").hover(function () {
        var zoom = $(this).find('.product__media img').data('zoom');
        var zoomimg = '  <img role="presentation" alt="" src="'+zoom+'" class="zoomImg" style="position: absolute; top:0; left: -42.324px; opacity: 1; width: 1000px; height: 1000px; border: none; max-width: none; max-height: none;">';
        $(this).find('.product__media').append(zoomimg);
    },
    function (){
        $('.zoomImg').remove();
    });
  
    $("modal-opener").mousemove(function (event) {
        var relX = event.pageX - $(this).offset().left;
        relX = relX - (relX * 2); 
        var relY = event.pageY - $(this).offset().top;
        relY = relY - (relY * 2);
        $('.zoomImg').css({"left": relX, "top":relY});
    });
   if (window.matchMedia('(max-width: 989px)').matches) { 
    $('details.mobile-facets__disclosure.disclosure-has-popup').removeAttr('open');
  }
     $('.thumbnail-list').delegate('.thumbnail-list__item','click',function() { 
      var data_target = $(this).data('target');
     $('.product__media-item').removeClass('is-active');
     $('#Slide-'+data_target).addClass('is-active');
  
  });


document.querySelectorAll('.loox-rating, .pro_title_wrapper .title_review_count, .sticky_add_to_cart_review .title_review_count, .wr-review')
  .forEach(function(element) {
    element.addEventListener('click', function() {
      const proReviews = document.querySelector('#proReviews');
      if (proReviews) {
        const topPosition = proReviews.getBoundingClientRect().top + window.scrollY - 250;
        window.scrollTo({
          top: topPosition,
          behavior: 'smooth'
        });
        console.log('test1');
      }
    });
  });

document.querySelector('body .loox-rating').addEventListener('click', function(e) {
  const proReviews = document.querySelector('#proReviews');
  if (proReviews) {
    const topPosition = proReviews.getBoundingClientRect().top + window.scrollY - 250;
    window.scrollTo({
      top: topPosition,
      behavior: 'smooth'
    });
    console.log('test2');
  }
});
}
$(function(){
 theme.ProductPage();
});
